import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BestIVFCentreAmbala from "./SEO/BestIVFCentreAmbala";
import IVFTreatmentAmbala from "./SEO/IVFTreatmentAmbala";
import FertilityClinicAmbala from "./SEO/FertilityClinicAmbala";
import TestTubeBabyCentreAmbala from "./SEO/TestTubeBabyCentreAmbala";
import IVFSpecialistAmbala from "./SEO/IVFSpecialistAmbala";
import IVFCostAmbala from "./SEO/IVFCostAmbala";
import IUITreatmentAmbala from "./SEO/IUITreatmentAmbala";
import ICSITreatmentAmbala from "./SEO/ICSITreatmentAmbala";
import FemaleInfertilityAmbala from "./SEO/FemaleInfertilityAmbala";
import MaleInfertilityAmbala from "./SEO/MaleInfertilityAmbala";
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import StickyBookNow from './Components/BoookAppointment/StickyBookNow';
import OpeningCeremony from './Components/Blogs/openingCeremony/openingCeremony.jsx';
// Pages
import DistrictSEOPage from "./SEO/DistrictSeoPage";

import Home from './Components/Home/Home';
import About from './Components/AboutUs/About';
import Contact from './Components/Contact/Contact';
import BookAppointment from './Components/BoookAppointment/BookAppointment';
import Doctors from './Components/AboutUs/Doctors.jsx';
// Services
import IVFService from './Components/Service/IVFService';
import IUIService from './Components/Service/IUIService';
import ICSI from './Components/Service/ICSIService';
import Oocyte from './Components/Service/Ooctye.js';
import EmbryoTransfer from './Components/Service/EmbryoTransfer';
import EggDonor from './Components/Service/EggDonor';
import Gynae from './Components/Service/Gynae';
import Pediatrics from './Components/Service/Pediatrics';
import Career from './Components/Career/Career.js';

import ScrollToTop from './Components/ScrolltoTop.js';

function App() {
  return (
    <BrowserRouter>

      {/* ✅ GLOBAL SEO (VERY IMPORTANT) */}
      <Helmet>
        <html lang="en" />

        <meta charSet="utf-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1" />

        <meta name="robots" content="index, follow" />

        <meta name="author" content="Amaanat IVF Clinic" />

        {/* Google Verification (ADD YOUR CODE LATER) */}
        {/* <meta name="google-site-verification" content="XXXX" /> */}

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalOrganization",
            "name": "Amaanat IVF Clinic",
            "url": "https://amaanativf.com",
            "logo": "https://amaanativf.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9991641100",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": "English"
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            },
            "sameAs": [
              "https://www.facebook.com/",
              "https://www.instagram.com/"
            ]
          })}
        </script>
      </Helmet>

      <StickyBookNow />
      <ScrollToTop />
      <Header />

      <Routes>

        {/* MAIN PAGES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/bookappointment" element={<BookAppointment />} />
          <Route path='Doctors' element={<Doctors />} />
        {/* SERVICES */}
        <Route path="/services/ivf" element={<IVFService />} />
        <Route path="/services/iui" element={<IUIService />} />
        <Route path="/services/icsi" element={<ICSI />} />
        <Route path="/services/oocyte" element={<Oocyte />} />
        <Route path="/services/embryo" element={<EmbryoTransfer />} />
        <Route path="/services/donor" element={<EggDonor />} />
        <Route path="/services/gynae" element={<Gynae />} />
        <Route path="/services/pediatrics" element={<Pediatrics />} />
        <Route path="/openingCeremony" element={<OpeningCeremony />} />


<Route path="/best-ivf-centre-in-ambala" element={<BestIVFCentreAmbala />} />
<Route path="/ivf-treatment-in-ambala" element={<IVFTreatmentAmbala />} />
<Route path="/fertility-clinic-in-ambala" element={<FertilityClinicAmbala />} />
<Route path="/test-tube-baby-centre-in-ambala" element={<TestTubeBabyCentreAmbala />} />
<Route path="/ivf-specialist-in-ambala" element={<IVFSpecialistAmbala />} />
<Route path="/ivf-cost-in-ambala" element={<IVFCostAmbala />} />
<Route path="/iui-treatment-in-ambala" element={<IUITreatmentAmbala />} />
<Route path="/icsi-treatment-in-ambala" element={<ICSITreatmentAmbala />} />
<Route path="/female-infertility-treatment-in-ambala" element={<FemaleInfertilityAmbala />} />
<Route path="/male-infertility-treatment-in-ambala" element={<MaleInfertilityAmbala />} />
        {/* CAREER */}
        <Route path="/career" element={<Career />} />

<Route
  path="/ivf-treatment-for-patients-from/:district"
  element={<DistrictSEOPage />}
/>
        {/* ✅ SEO IMPORTANT: 404 PAGE */}
        <Route path="*" element={
          <div style={{ padding: "100px", textAlign: "center" }}>
            <h1>404 - Page Not Found</h1>
            <p>This page does not exist.</p>
          </div>
        } />

      </Routes>

      <Footer />

    </BrowserRouter>
  );
}

export default App;